import { useContext } from 'react';

import Button3D from '@/components/game/3d/object/button/Button3D';
import FactoryComposed from '@/components/game/3d/object/piece/FactoryComposed';
import { GameContext, ViewContext } from '@/state/contexts';
import { buyFactory } from '@lc/const/socketEvent';
import { calculateFactoryCost } from '@lc/lib/playermat_helper';

// IF possible to buy (right player, can afford it) display buy button

const FactoryBuilder = ({ factories, playerId, payForAction }) => {
	if (factories == null) return null;
	// create element at position-x = n * 1.5  for each numFactory

	const { myState }: any = useContext(GameContext);

	const { pPE, pPC }: any = useContext(ViewContext);

	const factoryArray: any = [];

	// const STEP = 1.5;
	// const prev = useRef(factoryEnergyArr);

	for (let i = 0; i < factories; i++) {
		factoryArray.push(
			<FactoryComposed key={`factory_${playerId}_${i}`} index={i} />
		);
	}

	function clientBuyFactory() {
		const factoryCost = calculateFactoryCost(myState);
		payForAction(buyFactory, factoryCost);
	}

	function getOffset() {
		return (factories - 2) * 1.45;
	}

	return (
		<>
			<group
				key={`factory_group_${playerId}`}
				position={[-2, 5.5, 12.75]}
			>
				{factoryArray}
				{factories < 6 &&
					pPE + pPC >= calculateFactoryCost(myState) && (
						<Button3D
							buttonAction={clientBuyFactory}
							playerId={playerId}
							p={[3 + getOffset(), 0, -0.75]}
						/>
					)}
			</group>
		</>
	);
};

export default FactoryBuilder;
